import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { DrivingExceptionsState } from '../types';
import { drivingExceptionsState } from './drivingExceptionsState';

export const driverExceptionsSlice = createSlice({
  name: 'driverExceptions',
  initialState: drivingExceptionsState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setDataReset(state) {
      state = drivingExceptionsState;
    },
    setHosDriverExceptions(
      state,
      action: PayloadAction<DrivingExceptionsState['hosDriverExceptions']>,
    ) {
      state.hosDriverExceptions = action.payload;
    },
    setHosHiddenDriverExceptions(
      state,
      action: PayloadAction<
        DrivingExceptionsState['hosHiddenDriverExceptions']
      >,
    ) {
      state.hosHiddenDriverExceptions = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: driverExceptionsActions } = driverExceptionsSlice;

/* ------- STATE SELECTORS ------- */
export const selectDriverExceptions = (state: RootState) =>
  state.driverExceptions;

export default driverExceptionsSlice.reducer;
